const auth = {
  reset () {
    localStorage.removeItem('whoAmI')
  },

  save (whoAmI) {
    localStorage.setItem('whoAmI', JSON.stringify(whoAmI))
  },

  whoAmI () {
    const whoAmI = localStorage.getItem('whoAmI')
    return JSON.parse(whoAmI)
  }
}

export { auth }

export default {
  install (Vue) {
    Vue.prototype.$auth = auth
  }
}
